import axios from 'axios';
import { endpoint, } from "./utils.js";

export async function sendAdvenirTestData(useAlerts, parkId, transactionId = null) {
  const payload = transactionId === null ? {} : { 'transaction_id': transactionId };
  try {
    const res = await axios.post(
      endpoint(`internal/current/parks/${parkId}/send_advenir_test_data/`),
      payload, {
        withCredentials: true
      });
    if (res.status !== 200) {
      useAlerts.value.warningAlert(`Anomalous return code!`, `${res.status} ${res.data}`);
      return;
    }
    useAlerts.value.successAlert(
      `Advenir Test Data scheduled for send`,
      `Wait 2-3 minutes to verify with them if this has been succesfully`
    );
  } catch (e) {
    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      useAlerts.value.errorAlert(`Error ${e.response.status}`, `${JSON.stringify(e.response.data)}`);
    } else if (e.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      useAlerts.value.errorAlert(`No response received!`, `${JSON.stringify(e.request)}`);
    } else {
      // Something happened in setting up the request that triggered an Error
      useAlerts.value.errorAlert(`Unexpected Error!`, `${JSON.stringify(e.message)}`);
    }
  }
}
